class HelloARLegacyTracker {
    constructor({ server }) {
        this.isUserInAR = false;
        this.didRequest = false;
        this.didLoad = false;
        this.didView = false;
        this.didInteract = false;
        this.useProdServer = () => {
            this.serverURL = "https://api.helloviewer.io";
        };
        this.useDevServer = () => {
            this.serverURL = "https://dev.api.helloviewer.io";
        };
        this.reset = () => {
            this.sessionId = "";
            this.productId = "";
            this.applicationId = "";
            this.didRequest = false;
            this.didLoad = false;
            this.didView = false;
            this.didInteract = false;
            this.isUserInAR = false;
            clearInterval(this.interactiveHeartbeat);
            this.interactiveHeartbeat = undefined;
        };
        this.getRequestedURL = () => {
            var mandatoryParameters = `product_id=${this.productId}&application_id=${this.applicationId}&session_id=${this.sessionId}`;
            if (this.viewerId != "") {
                mandatoryParameters = `${mandatoryParameters}&viewer_id=${this.viewerId}`;
            }
            if (this.parentSessionId != "") {
                mandatoryParameters = `${mandatoryParameters}&appliction_account_usage_session_id=${this.parentSessionId}`;
            }
            return `${this.serverURL}/session/requested?${mandatoryParameters}`;
        };
        this.getLoadedURL = () => {
            return `${this.serverURL}/session/loaded?session_id=${this.sessionId}`;
        };
        this.getViewedURL = () => {
            return `${this.serverURL}/session/viewed?session_id=${this.sessionId}`;
        };
        this.getInteractedURL = () => {
            return `${this.serverURL}/session/interacted?session_id=${this.sessionId}`;
        };
        this.getArStartedURL = () => {
            return `${this.serverURL}/session/ar_started?session_id=${this.sessionId}`;
        };
        this.getArEndedURL = () => {
            return `${this.serverURL}/session/ar_ended?session_id=${this.sessionId}`;
        };
        this.manageInteractiveHeartbeat = () => {
            fetch(this.getInteractedURL(), { method: "POST" });
        };
        this.requested = (productId, applicationId) => {
            if (this.didRequest) {
                return;
            }
            this.didRequest = true;
            this.productId = productId;
            this.applicationId = applicationId;
            fetch(this.getRequestedURL(), { method: "POST" });
        };
        this.loaded = () => {
            if (!this.didRequest || this.didLoad) {
                return;
            }
            this.didLoad = true;
            fetch(this.getLoadedURL(), { method: "POST" });
        };
        this.viewed = () => {
            if (!this.didRequest || this.didView) {
                return;
            }
            this.didView = true;
            fetch(this.getViewedURL(), { method: "POST" });
        };
        this.interacted = () => {
            if (!this.didRequest || this.didInteract) {
                return;
            }
            this.didInteract = true;
            this.interactiveHeartbeat = setInterval(this.manageInteractiveHeartbeat, 5000);
            fetch(this.getInteractedURL(), { method: "POST" });
        };
        this.interactiveSessionStopped = () => {
            this.didInteract = false;
            clearInterval(this.interactiveHeartbeat);
        };
        this.arStarted = () => {
            if (!this.didRequest || this.isUserInAR) {
                return;
            }
            this.isUserInAR = true;
            this.interactiveSessionStopped();
            fetch(this.getArStartedURL(), { method: "POST" });
        };
        this.arStopped = () => {
            if (!this.didRequest || !this.isUserInAR) {
                return;
            }
            this.isUserInAR = false;
            fetch(this.getArEndedURL(), { method: "POST" });
        };
        this.setSessionId = (sessionId) => {
            this.sessionId = sessionId;
        };
        this.setParentSessionId = (parentSessionId) => {
            this.parentSessionId = parentSessionId;
        };
        this.setViewerId = (viewerId) => {
            this.viewerId = viewerId;
        };
        this.reset();
        this.serverURL = "";
        this.viewerId = "";
        this.parentSessionId = "";
        this.productId = "";
        this.applicationId = "";
        this.sessionId = "";
        if (server === "PROD") {
            this.useProdServer();
        }
        else {
            this.useDevServer();
        }
        document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "visible") {
                if (this.isUserInAR) {
                    this.arStopped();
                }
            }
            else {
                this.interactiveSessionStopped();
            }
        });
    }
}
export default HelloARLegacyTracker;
